import { Component } from 'react';

export default class Dropdown extends Component {
  state = { on: false };

  getStateAndHelpers() {
    const { on } = this.state;
    return {
      on,
      toggle: this.toggle,
      toggleOff: this.toggleOff,
      togglerProps: {
        onClick: this.toggle,
      },
    };
  }

  toggleOff = () => this.setState(() => ({ on: false }));

  toggle = e => {
    const { onToggle } = this.props;
    e.stopPropagation();
    this.setState(
      ({ on }) => ({ on: !on }),
      () => {
        const { on } = this.state;
        onToggle(on);
      }
    );
  };

  render() {
    const { children } = this.props;
    return children(this.getStateAndHelpers());
  }
}



// WEBPACK FOOTER //
// ./src/components/common/Dropdown/Dropdown.js